export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-collection/src/keys.js
// module id = 978
// module chunks = 1